export default "__VITE_PUBLIC_ASSET__c3c1e733__"